import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  updateDeviceStatusFailed,
  updateDeviceStatusStart,
  updateDeviceStatusSuccess,
} from "../redux/updateDeviceStatus";
import { updateStatusDeviceAPI } from "core/http/service/notification";

function* updateDeviceStatusWork(action) {
  const { callback, ...payload } = action.payload;
  try {
    const res = yield call(updateStatusDeviceAPI, payload);
    yield put({
      type: updateDeviceStatusSuccess.type,
      payload: res,
    });
    if (callback) {
      callback();
    }
  } catch (error: any) {
    yield put({
      type: updateDeviceStatusFailed.type,
    });
  }
}

function* watchUpdateDeviceStatus() {
  yield takeLatest(updateDeviceStatusStart.type, updateDeviceStatusWork);
}
export default function* updateDeviceStatusSaga() {
  yield all([watchUpdateDeviceStatus()]);
}
